import { graphql } from 'react-apollo'
import { getUsersQuery } from '../queries'
import AdminUserList from '../components/adminUserList'

export default graphql(getUsersQuery)(AdminUserList)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminUserList.js